import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";
import Loader from "./Panel/adminComp/Dashboard/Loader";
import { Suspense, lazy } from "react";
import ProtectedRoutes from "./ProtectedRoutes";

const Dashboard = lazy(() => import("./Panel/adminComp/Dashboard/Dashboard"));
const ForgotPass = lazy(() =>
  import("./Panel/adminComp/adminLogin/forgotPass")
);
const OtpVerify = lazy(() => import("./Panel/adminComp/adminLogin/OtpVerify"));
const ResetPassword = lazy(() =>
  import("./Panel/adminComp/adminLogin/ResetPassword")
);
const StudentManage = lazy(() =>
  import("./Panel/adminComp/Dashboard/Student/StudentManage")
);
const TeacherManage = lazy(() =>
  import("./Panel/adminComp/Dashboard/Teachers/TeacherManage")
);
const SubjectManage = lazy(() =>
  import("./Panel/adminComp/Dashboard/Subjects/SubjectManage")
);
const QuestionManage = lazy(() =>
  import("./Panel/adminComp/Dashboard/QuestionsPaper/QuestionManage")
);
const SubscriptionPlanManagement = lazy(() =>
  import(
    "./Panel/adminComp/Dashboard/SubscriptionManage/SubscriptionPlanManagement"
  )
);
const Promocode = lazy(() =>
  import("./Panel/adminComp/Dashboard/Promo/Promocode")
);
const PushNotification = lazy(() =>
  import("./Panel/adminComp/Dashboard/PushNotification/PushNotification")
);
const MyTransaction = lazy(() =>
  import("./Panel/adminComp/Dashboard/Transaction/MyTransaction")
);
const Notification = lazy(() =>
  import("./Panel/adminComp/Dashboard/Notification/Notification")
);
const HelpNSupport = lazy(() =>
  import("./Panel/adminComp/Dashboard/HelpNSupport/HelpNSupport")
);
const ContentManagement = lazy(() =>
  import("./Panel/adminComp/Dashboard/ContentManag/ContentManagement")
);
const TeacherDetails = lazy(() =>
  import("./Panel/adminComp/Dashboard/Teachers/TeacherDetails")
);
const StudentDetails = lazy(() =>
  import("./Panel/adminComp/Dashboard/Student/StudentDetails")
);
const SubjectDetails = lazy(() =>
  import("./Panel/adminComp/Dashboard/Subjects/SubjectDetails")
);
const ViewAllQuestions = lazy(() =>
  import("./Panel/adminComp/Dashboard/QuestionsPaper/ViewAllQuestions")
);
const QuestionDetails = lazy(() =>
  import("./Panel/adminComp/Dashboard/QuestionsPaper/QuestionDetails")
);
const ViewSubscriptionPlan = lazy(() =>
  import("./Panel/adminComp/Dashboard/SubscriptionManage/ViewSubscriptionPlan")
);
const PushNotificationView = lazy(() =>
  import("./Panel/adminComp/Dashboard/PushNotification/PushNotificationView")
);
const TransactionDetails = lazy(() =>
  import("./Panel/adminComp/Dashboard/Transaction/TransactionDetails")
);
const ViewProfile = lazy(() => import("./Panel/adminComp/ViewProfile"));
const ChangePass = lazy(() =>
  import("./Panel/adminComp/adminLogin/ChangePass")
);
const ExamSubjectDetails = lazy(() =>
  import("./Panel/adminComp/Dashboard/Student/ExamSubjectDetails")
);
const Login = lazy(() => import("./Panel/adminComp/adminLogin/Login"));

function App() {
  return (
    <div className="App">
      <RecoilRoot>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <Suspense fallback={<Loader />}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={<Loader />}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/admin/login"
              element={
                <Suspense fallback={<Loader />}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/admin/login/forgot-pass"
              element={
                <Suspense fallback={<Loader />}>
                  <ForgotPass />
                </Suspense>
              }
            />
            <Route
              path="/admin/login/otp-verify/:mail"
              element={
                <Suspense fallback={<Loader />}>
                  <OtpVerify />
                </Suspense>
              }
            />
            <Route
              path="/admin/login/reset-password/:mail"
              element={
                <Suspense fallback={<Loader />}>
                  <ResetPassword />
                </Suspense>
              }
            />

            {/* Admin Protected Routes */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <Dashboard />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/view-profile"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <ViewProfile />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/change-password"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <ChangePass />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/student-management"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <StudentManage />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/student-management/student-details/:id"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <StudentDetails />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/teacher-management"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <TeacherManage />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/teacher-management/teacher-details/:id"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <TeacherDetails />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/subject-management"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <SubjectManage />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/subject-management/subject-details/:id"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <SubjectDetails />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/question-paper-management"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <ViewAllQuestions />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/question-details/123"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <QuestionDetails />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/subscription-plan-management"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <SubscriptionPlanManagement />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/promocode-management"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <Promocode />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/subscription/view-plan/:id"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <ViewSubscriptionPlan />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/push-notification"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <PushNotification />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/push-notification-view/:id"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <PushNotificationView />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/my-transaction"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <MyTransaction />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/transaction-details/:id"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <TransactionDetails />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/notification"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <Notification />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/help-support"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <HelpNSupport />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/content-management-system"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <ContentManagement />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
            <Route
              path="/admin/student/exam-details/:id"
              element={
                <ProtectedRoutes>
                  <Suspense fallback={<Loader />}>
                    <ExamSubjectDetails />
                  </Suspense>
                </ProtectedRoutes>
              }
            />
          </Routes>
        </BrowserRouter>
      </RecoilRoot>
    </div>
  );
}

export default App;
